module.exports = __webpack_public_path__ + "img/key-black.2bc4a05a.svg";